import { Box, IconButton } from "@mui/material";
import { PaginationModel } from "utils/PaginationType";
import { Edit } from "@mui/icons-material";
import { Delete } from "@mui/icons-material";
import { Category, Product } from "./ProductType";
import { formatPrice } from "utils/helper";
import { SearchProductParams } from "./ProductManagement";

export const CategoryTableColumns = (fetchCategories: (page: number, pageSize: number) => Promise<any>, paginationModel: PaginationModel, handleEdit: (category: Category) => void, handleDelete: (category: Category) => void) => {
  return [
    { field: 'id', headerName: 'ID', width: 100, flex: 1 },
    { field: 'name', headerName: 'Tên', width: 100, flex: 1 },
    { field: 'description', headerName: 'Mô tả', width: 100, flex: 1 },
    { field: 'code', headerName: 'Mã', width: 100, flex: 1 },
    { field: 'isActive', headerName: 'Trạng thái', width: 100, flex: 1 },
    { field: 'actions', headerName: 'Hành động', width: 100, flex: 1, renderCell: (params: any) => {
      return <>
      <IconButton color="primary" title="Chỉnh sửa" onClick={() => {
        handleEdit(params.row);
      }}>
        <Edit sx={{ fontSize: 20 }} />
      </IconButton>
      <IconButton color="error" title="Xóa" onClick={() => {
        handleDelete(params.row);
      }}>
        <Delete sx={{ fontSize: 20 }}   />
      </IconButton>
      </>;
    } },
  ];
};

export const ProductTableColumns = (
  fetchProducts: (page: number, pageSize: number, search: SearchProductParams) => Promise<any>,
  paginationModel: PaginationModel,
  handleEdit: (product: Product) => void,
  handleDelete: (product: Product) => void
) => {
  return [
    { field: 'id', headerName: 'ID', width: 100, flex: 1, sortable: false },
    { field: 'name', headerName: 'Tên', width: 100, flex: 1, sortable: false },
    { field: 'description', headerName: 'Mô tả', width: 100, flex: 1, sortable: false, renderCell: (params: any) => {
      return <Box sx={{ maxHeight: 100, overflow: 'auto' }}>{params.row.description}</Box>;
    } },
    { field: 'categories', headerName: 'Danh mục', width: 100, flex: 1, renderCell: (params: any) => {
      return <>{params.row.categories.join(', ')}</>;
    } , sortable: false},
    { field: 'basePrice', headerName: 'Giá cơ bản', width: 100, flex: 1, renderCell: (params: any) => {
      return <>{formatPrice(params.row.basePrice)}</>;
    } , sortable: false},
    { field: 'isActive', headerName: 'Trạng thái', width: 100, flex: 1, sortable: false },
    { field: 'actions', headerName: 'Hành động', width: 100, flex: 1, renderCell: (params: any) => {
      return <>
      <IconButton color="primary" title="Chỉnh sửa" onClick={() => {
        handleEdit(params.row);
      }}>
        <Edit sx={{ fontSize: 20 }} />
      </IconButton>
      <IconButton color="error" title="Xóa" onClick={() => {
        handleDelete(params.row);
      }}>
        <Delete sx={{ fontSize: 20 }} />
      </IconButton>
      </>;
    } , sortable: false},
  ];
};

export const CategoryDefaultValues: Category = {
  id: 0,
  name: '',
  description: '',
  code: '',
  isActive: true,
};

export const ProductDefaultValues: Product = {
  id: 0,
  name: '',
  description: '',
  basePrice: 0,
  categories: [],
  sizes: [],
  materials: [],
  photos: [],
  addons: [],
};